import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import { useCustomTranslations } from '../../../../../../hooks/useCustomTranslations';
import { SpeakerEntry } from '../../../../../../interfaces/pagebuilder';
import { createDisplayLink } from '../../../../../../services/helper';

interface SpeakerProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  speaker: SpeakerEntry;
  onSelect: () => void;
  showPosition: boolean;
}

const SpeakerComponent = ({ speaker, onSelect, showPosition, ...props }: SpeakerProps) => {
  function handleSpeakerClick() {
    // if (speaker.url) window.open(speaker.url, '_blank');
    if (speaker.hasModal) onSelect();
  }
  const { ct } = useCustomTranslations();

  return (
    <div
      className={`${props.className ? props.className : ''}`}
      onClick={handleSpeakerClick}
      style={{ ...(speaker.hasModal ? { cursor: 'pointer' } : {}), height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.7)', borderRadius: '0.2rem' }}>
      <div
        style={{ backgroundImage: `url(${createDisplayLink(speaker.image, undefined, undefined, undefined, undefined, undefined, true, true)})` }}
        className="rounded-t bg-cover bg-center bg-white w-52 h-52 relative group">
        <div className="absolute w-full h-full flex justify-center items-center opacity-0 group-hover:opacity-50 bg-white">
          <SearchIcon style={{ fontSize: '6rem' }} />
        </div>
      </div>
      <div className="w-52 bottom-0 flex flex-col justify-start items-center p-3">
        <span className="break-words white-space-prewrap hyphens-auto text-xl text-center mb-2">{ct(speaker.name, speaker, 'nameTranslation')}</span>
        {showPosition && <span className="break-words white-space-prewrap hyphens-auto">{ct(speaker.position, speaker, 'positionTranslation')}</span>}
      </div>
    </div>
  );
};

export default SpeakerComponent;
